import { render, staticRenderFns } from "./info_overview_mobile.vue?vue&type=template&id=3c04bdcd"
import script from "./info_overview_mobile.vue?vue&type=script&lang=js"
export * from "./info_overview_mobile.vue?vue&type=script&lang=js"
import style0 from "./info_overview_mobile.vue?vue&type=style&index=0&id=3c04bdcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports